import { GridAction } from '@eforall/dashboard';
import { Course } from '@interfaces';

export function getActions() {

	const actions: GridAction<Course>[] = [];

	return actions;
}